/**
 * BorowkaHome — Room Planner: каталог наборов стикеров
 *
 * Growth Charts (type: "growth_chart"):
 *   SKU: BH-[DESIGN]-[UNIT]-[PERS]  (UNIT: CM|IN, PERS: WN|PR)
 *   URL хранится в variants[key].url (полный CDN URL с суффиксом Shopify)
 *   Если url начинается с "PLACEHOLDER" — файл ещё не загружен
 *
 * Sticker Sets (type: "sticker_set"):
 *   URL изображения: cdn_base + sku + "-" + element_id + ".png"
 *   Если у элемента есть поле `file` — используется cdn_base + file (override)
 *   Пример: https://cdn.shopify.com/.../BH-BALLOON-1-balloon1.png
 *
 * Подробная инструкция: docs/features/room-planner-sku-guide.md
 */
window.RoomPlannerData = {

  // База CDN — обновить после загрузки файлов в Shopify Files
  cdn_base: "https://cdn.shopify.com/s/files/1/0938/4185/0441/files/",

  sets: [
    {
      id: "BH-SLEEPINGANIMALS",
      design: "SLEEPINGANIMALS",
      product_handle: "growth-charts",
      product_title: "Sleeping Animals Growth Chart",
      type: "growth_chart",
      category: "growth-charts",
      price: 0,        // cents — заполнить когда product создан
      variantId: null,  // Shopify variant ID — заполнить когда product создан

      // Варианты по единицам и персонализации
      variants: {
        "CM-WN": {
          sku: "BH-SLEEPINGANIMALS-CM-WN", unit: "cm", personalized: false,
          url: "https://cdn.shopify.com/s/files/1/0938/4185/0441/files/BH-SLEEPINGANIMALS-CM-WN_800x800.png?v=1773415775"
        },
        "CM-PR": {
          sku: "BH-SLEEPINGANIMALS-CM-PR", unit: "cm", personalized: true,
          url: "https://cdn.shopify.com/s/files/1/0938/4185/0441/files/BH-SLEEPINGANIMALS-CM-PR_800x800.png?v=1773415775"
        },
        "IN-WN": {
          sku: "BH-SLEEPINGANIMALS-IN-WN", unit: "inch", personalized: false,
          url: "https://cdn.shopify.com/s/files/1/0938/4185/0441/files/BH-SLEEPINGANIMALS-IN-WN_800x800.png?v=1773415347"
        },
        "IN-PR": {
          sku: "BH-SLEEPINGANIMALS-IN-PR", unit: "inch", personalized: true,
          url: "https://cdn.shopify.com/s/files/1/0938/4185/0441/files/BH-SLEEPINGANIMALS-IN-PR_800x800.png?v=1773415775"
        }
      },

      // Реальные размеры
      width_cm: 28,
      height_cm: 123,

      personalization: {
        type: "text_on_element",
        position: "top",
        offset_y_percent: 5,
        default_text: "Emma",
        fonts: ["Nunito", "Pacifico", "Dancing Script", "Fredoka One"],
        colors: ["#2F3428", "#6B7F4A", "#D4937D", "#8FA76D", "#C17B5C", "#FFFFFF"]
      }
    },
    {
      id: "BH-BALLOON-1",
      sku: "BH-BALLOON-1",
      product_handle: "hot-air-balloon-animals-wall-decals",
      product_title: "Hot Air Balloons",
      type: "sticker_set",
      category: "sets",
      price: 3600,
      variantId: "54590956732489",
      elements: [
        { id: "S1-31x42", name: "Balloon with Bear",   width_cm: 31, height_cm: 42, qty: 1 },
        { id: "S2-36x38", name: "Balloon with Bunny",  width_cm: 36, height_cm: 38, qty: 1 },
        { id: "S3-22x35", name: "Balloon with Fox",    width_cm: 22, height_cm: 35, qty: 1 },
        { id: "S4-25x37", name: "Balloon with Koala",  width_cm: 25, height_cm: 37, qty: 1 },
        { id: "S5-26x42", name: "Balloon with Panda",  width_cm: 26, height_cm: 42, qty: 1 }
      ]
    },
    {
      id: "BH-BUNNY-S",
      sku: "BH-BUNNY-S",
      product_handle: "bunny-sweet-wall-decals",
      product_title: "Bunny Sweet",
      type: "sticker_set",
      category: "sets",
      price: 2400,
      variantId: "54590954897481",
      elements: [
        { id: "S1-26x23",    name: "Bunny with Flowers",  width_cm: 26, height_cm: 23, qty: 1  },
        { id: "S2-24x15",    name: "Sleeping Bunny",      width_cm: 24, height_cm: 15, qty: 1  },
        { id: "S3-13x14",    name: "Sitting Bunny",       width_cm: 13, height_cm: 14, qty: 1  },
        { id: "S4-26x16",    name: "Flower Branch Left",  width_cm: 26, height_cm: 16, qty: 1  },
        { id: "S5-26x16",    name: "Flower Branch Right", width_cm: 26, height_cm: 16, qty: 1  },
        { id: "S6-3x4-x12", name: "Butterfly",           width_cm: 3,  height_cm: 4,  qty: 12 },
        { id: "S7-2x2-x24", name: "Petal",               width_cm: 2,  height_cm: 2,  qty: 24 }
      ]
    },
    {
      id: "BH-BUNNY-XL",
      sku: "BH-BUNNY-XL",
      product_handle: "bunny-xl-wall-decals",
      product_title: "Bunny XL",
      type: "sticker_set",
      category: "sets",
      price: 3800,
      variantId: "54590954930249",
      elements: [
        { id: "S1-44x40",     name: "Bunny with Flowers",  width_cm: 44, height_cm: 40, qty: 1  },
        { id: "S2-45x28",     name: "Sleeping Bunny",      width_cm: 45, height_cm: 28, qty: 1  },
        { id: "S3-45x27",     name: "Sitting Bunny",       width_cm: 45, height_cm: 27, qty: 1  },
        { id: "S4-41x25",     name: "Flower Branch Left",  width_cm: 41, height_cm: 25, qty: 1  },
        { id: "S5-18x20",     name: "Flower Branch Right", width_cm: 18, height_cm: 20, qty: 1  },
        { id: "S6-6x6-x12",   name: "Butterfly",           width_cm: 6,  height_cm: 6,  qty: 12 },
        { id: "S7-4x4-x22",   name: "Petal",               width_cm: 4,  height_cm: 4,  qty: 22 }
      ]
    },
    {
      id: "BH-DINO-1",
      sku: "BH-DINO-1",
      product_handle: "dinosaurs-wall-decals",
      product_title: "Dinosaurs",
      type: "sticker_set",
      category: "sets",
      price: 3400,
      variantId: "54590958501961",
      elements: [
        { id: "S1-24x21",  name: "T-Rex",          width_cm: 24, height_cm: 21, qty: 1 },
        { id: "S2-26x15",  name: "Stegosaurus",    width_cm: 26, height_cm: 15, qty: 1 },
        { id: "S3-21x20",  name: "Triceratops",    width_cm: 21, height_cm: 20, qty: 1 },
        { id: "S4-21x26",  name: "Brontosaurus",   width_cm: 21, height_cm: 26, qty: 1 },
        { id: "S5-21x16",  name: "Pterodactyl",    width_cm: 21, height_cm: 16, qty: 1 },
        { id: "S6-17x9",   name: "Baby Dino",      width_cm: 17, height_cm: 9,  qty: 1 },
        { id: "S7-29x18",  name: "Ankylosaurus",   width_cm: 29, height_cm: 18, qty: 1 },
        { id: "S8-25x17",  name: "Parasaurolophus", width_cm: 25, height_cm: 17, qty: 1 },
        { id: "S9-21x19",  name: "Raptor",         width_cm: 21, height_cm: 19, qty: 1 },
        { id: "S10-25x21", name: "Diplodocus",     width_cm: 25, height_cm: 21, qty: 1 },
        { id: "S11-24x17", name: "Spinosaurus",    width_cm: 24, height_cm: 17, qty: 1 },
        { id: "S12-26x15", name: "Palm Tree",      width_cm: 26, height_cm: 15, qty: 1 },
        { id: "S13-26x15", name: "Volcano",        width_cm: 26, height_cm: 15, qty: 1 }
      ]
    },
    {
      id: "BH-PILOTS-L",
      sku: "BH-PILOTS-L",
      product_handle: "pilots-wall-decals-l",
      product_title: "Pilots L",
      type: "sticker_set",
      category: "sets",
      price: 3700,
      variantId: "54590956175433",
      elements: [
        { id: "S1-39x36",    name: "Pilot Bear",      width_cm: 39, height_cm: 36, qty: 1  },
        { id: "S2-36x35",    name: "Pilot Bunny",     width_cm: 36, height_cm: 35, qty: 1  },
        { id: "S3-36x34",    name: "Pilot Fox",       width_cm: 36, height_cm: 34, qty: 1  },
        { id: "S4-29x29",    name: "Pilot Koala",     width_cm: 29, height_cm: 29, qty: 1  },
        { id: "S5-34x31",    name: "Pilot Panda",     width_cm: 34, height_cm: 31, qty: 1  },
        { id: "S6-5x4-x9",  name: "Cloud",           width_cm: 5,  height_cm: 4,  qty: 9  },
        { id: "S7-3x3-x16", name: "Star",            width_cm: 3,  height_cm: 3,  qty: 16 }
      ]
    },
    {
      id: "BH-PILOTS-XL",
      sku: "BH-PILOTS-XL",
      product_handle: "pilots-wall-decals-xl",
      product_title: "Pilots XL",
      type: "sticker_set",
      category: "sets",
      price: 7200,
      variantId: "54590956208201",
      elements: [
        { id: "S1-49x44",    name: "Pilot Bear",      width_cm: 49, height_cm: 44, qty: 1  },
        { id: "S2-46x45",    name: "Pilot Bunny",     width_cm: 46, height_cm: 45, qty: 1  },
        { id: "S3-36x36",    name: "Pilot Fox",       width_cm: 36, height_cm: 36, qty: 1  },
        { id: "S4-48x47",    name: "Pilot Koala",     width_cm: 48, height_cm: 47, qty: 1  },
        { id: "S5-44x41",    name: "Pilot Panda",     width_cm: 44, height_cm: 41, qty: 1  },
        { id: "S6-6x6-x12", name: "Cloud",           width_cm: 6,  height_cm: 6,  qty: 12 },
        { id: "S7-4x4-x24", name: "Star",            width_cm: 4,  height_cm: 4,  qty: 24 }
      ]
    },
    {
      id: "BH-SAILOR-1",
      sku: "BH-SAILOR-1",
      product_handle: "sailor-bear-wall-decals",
      product_title: "Sailor Bear",
      type: "sticker_set",
      category: "sets",
      price: 3700,
      variantId: "54590955028553",
      elements: [
        { id: "S1-43x61",    name: "Sailor Bear",     width_cm: 43, height_cm: 61, qty: 1  },
        { id: "S2-41x23",    name: "Sailing Boat",    width_cm: 41, height_cm: 23, qty: 1  },
        { id: "S3-27x19",    name: "Whale",           width_cm: 27, height_cm: 19, qty: 1  },
        { id: "S4-14x14",    name: "Lighthouse",      width_cm: 14, height_cm: 14, qty: 1  },
        { id: "S5-5x5-x7",  name: "Seagull",         width_cm: 5,  height_cm: 5,  qty: 7  },
        { id: "S6-3x3-x18", name: "Wave",            width_cm: 3,  height_cm: 3,  qty: 18 }
      ]
    },
    {
      id: "BH-SLEEPINGANIMALS-SET1",
      sku: "BH-SLEEPINGANIMALS-SET1",
      product_handle: "sleeping-animals-wall-decals-set-1",
      product_title: "Sleeping Animals Set 1",
      type: "sticker_set",
      category: "sets",
      price: 2800,
      variantId: "54590953979977",
      elements: [
        { id: "S1-46x45",    name: "Sleeping Bear",     width_cm: 46, height_cm: 45, qty: 1  },
        { id: "S2-31x34",    name: "Sleeping Bunny",    width_cm: 31, height_cm: 34, qty: 1  },
        { id: "S3-25x25",    name: "Sleeping Fox",      width_cm: 25, height_cm: 25, qty: 1  },
        { id: "S4-29x28",    name: "Sleeping Koala",    width_cm: 29, height_cm: 28, qty: 1  },
        { id: "S5-5x4-x11", name: "Moon",              width_cm: 5,  height_cm: 4,  qty: 11 },
        { id: "S6-3x3-x13", name: "Star",              width_cm: 3,  height_cm: 3,  qty: 13 }
      ]
    },
    {
      id: "BH-SLEEPINGANIMALS-SET2",
      sku: "BH-SLEEPINGANIMALS-SET2",
      product_handle: "sleeping-animals-wall-decals-set-2",
      product_title: "Sleeping Animals Set 2",
      type: "sticker_set",
      category: "sets",
      price: 3200,
      variantId: "54590954012745",
      elements: [
        { id: "S1-38x26",   name: "Sleeping Animal 1", width_cm: 38, height_cm: 26, qty: 1  },
        { id: "S2-34x34",   name: "Sleeping Animal 2", width_cm: 34, height_cm: 34, qty: 1  },
        { id: "S3-35x41",   name: "Sleeping Animal 3", width_cm: 35, height_cm: 41, qty: 1  },
        { id: "S4-38x26",   name: "Sleeping Animal 4", width_cm: 38, height_cm: 26, qty: 1  },
        { id: "S5-29x24",   name: "Sleeping Animal 5", width_cm: 29, height_cm: 24, qty: 1  },
        { id: "S6-5x4-x11", name: "Star Large",        width_cm: 5,  height_cm: 4,  qty: 11 },
        { id: "S6-3x3-x14", name: "Star Small",        width_cm: 3,  height_cm: 3,  qty: 14 }
      ]
    },
    {
      id: "BH-SPACE-1",
      sku: "BH-SPACE-1",
      product_handle: "space-adventure-wall-decals",
      product_title: "Space Adventure",
      type: "sticker_set",
      category: "sets",
      price: 3300,
      variantId: "54456811978825",
      elements: [
        { id: "S1-50x58",    name: "Rocket",            width_cm: 50, height_cm: 58, qty: 1  },
        { id: "S2-28x43",    name: "Astronaut Bear",    width_cm: 28, height_cm: 43, qty: 1  },
        { id: "S3-29x45",    name: "Astronaut Bunny",   width_cm: 29, height_cm: 45, qty: 1  },
        { id: "S4-21x27",    name: "Planet",            width_cm: 21, height_cm: 27, qty: 1  },
        { id: "S5-14x13",    name: "UFO",              width_cm: 14, height_cm: 13, qty: 1  },
        { id: "S6-58x12",    name: "Star Banner",       width_cm: 58, height_cm: 12, qty: 1  },
        { id: "S7-5x6-x12", name: "Star Large",        width_cm: 5,  height_cm: 6,  qty: 12 },
        { id: "S7-3x3-x10", name: "Star Small",        width_cm: 3,  height_cm: 3,  qty: 10 }
      ]
    },
    {
      id: "BH-BEES-1",
      sku: "BH-BEES-1",
      product_handle: "bees-honey-wall-decals",
      product_title: "Bees & Honey",
      type: "sticker_set",
      category: "sets",
      price: 2800,
      variantId: "54456792776777",
      elements: [
        { id: "S1-18x18",  name: "Bee with Honeypot",    width_cm: 18, height_cm: 18, qty: 1 },
        { id: "S2-20x21",  name: "Bear with Honey Jar",  width_cm: 20, height_cm: 21, qty: 1 },
        { id: "S3-18x19",  name: "Beehive",              width_cm: 18, height_cm: 19, qty: 1 },
        { id: "S4-11x11",  name: "Honey Dipper",         width_cm: 11, height_cm: 11, qty: 1 },
        { id: "S5-17x18",  name: "Flying Bee Large",     width_cm: 17, height_cm: 18, qty: 1 },
        { id: "S6-16x17",  name: "Honeycomb",            width_cm: 16, height_cm: 17, qty: 1 },
        { id: "S7-17x17",  name: "Bee on Flower",        width_cm: 17, height_cm: 17, qty: 1 },
        { id: "S8-11x12",  name: "Honey Drop",           width_cm: 11, height_cm: 12, qty: 1 },
        { id: "S9-15x15",  name: "Sunflower",            width_cm: 15, height_cm: 15, qty: 1 },
        { id: "S10-17x14", name: "Bee with Bucket",      width_cm: 17, height_cm: 14, qty: 1 },
        { id: "S11-12x13", name: "Small Bee",            width_cm: 12, height_cm: 13, qty: 1 },
        { id: "S13-14x15", name: "Daisy",                width_cm: 14, height_cm: 15, qty: 1 },
        { id: "S14-12x13", name: "Buzzing Bee",          width_cm: 12, height_cm: 13, qty: 1 },
        { id: "S15-13x15", name: "Clover",               width_cm: 13, height_cm: 15, qty: 1 },
        { id: "S16-17x14", name: "Bee with Pollen",      width_cm: 17, height_cm: 14, qty: 1 },
        { id: "S17-11x12", name: "Ladybug",              width_cm: 11, height_cm: 12, qty: 1 }
      ]
    },
    {
      id: "BH-DINO-SET1XL",
      sku: "BH-DINO-SET1XL",
      product_handle: "dinosaurs-set-1-xl-wall-decals",
      product_title: "Dinosaurs Set 1 XL",
      type: "sticker_set",
      category: "sets",
      price: 2300,
      variantId: "54456804704329",
      elements: [
        { id: "S1-33x53", name: "T-Rex XL",        width_cm: 33, height_cm: 53, qty: 1 },
        { id: "S2-24x23", name: "Triceratops XL",  width_cm: 24, height_cm: 23, qty: 1 }
      ]
    },
    {
      id: "BH-DINO-SET2XL",
      sku: "BH-DINO-SET2XL",
      product_handle: "dinosaurs-set-2-xl-wall-decals",
      product_title: "Dinosaurs Set 2 XL",
      type: "sticker_set",
      category: "sets",
      price: 2600,
      variantId: "54456804769865",
      elements: [
        { id: "S1-32x35", name: "Brontosaurus XL",    width_cm: 32, height_cm: 35, qty: 1 },
        { id: "S2-30x30", name: "Stegosaurus XL",     width_cm: 30, height_cm: 30, qty: 1 },
        { id: "S3-22x19", name: "Raptor XL",          width_cm: 22, height_cm: 19, qty: 1 },
        { id: "S4-18x12", name: "Baby Dinosaur XL",   width_cm: 18, height_cm: 12, qty: 1 }
      ]
    },
    {
      id: "BH-DINO-SET3XL",
      sku: "BH-DINO-SET3XL",
      product_handle: "dinosaurs-set-3-xl-wall-decals",
      product_title: "Dinosaurs Set 3 XL",
      type: "sticker_set",
      category: "sets",
      price: 1900,
      variantId: "54456804835401",
      elements: [
        { id: "S1-36x20", name: "Diplodocus XL",       width_cm: 36, height_cm: 20, qty: 1 },
        { id: "S2-22x33", name: "Spinosaurus XL",      width_cm: 22, height_cm: 33, qty: 1 },
        { id: "S3-23x31", name: "Pterodactyl XL",      width_cm: 23, height_cm: 31, qty: 1 }
      ]
    },
    {
      id: "BH-DRAGON-XL",
      sku: "BH-DRAGON-XL",
      product_handle: "dragons-xl-wall-decals",
      product_title: "Dragons XL",
      type: "sticker_set",
      category: "sets",
      price: 3900,
      variantId: "54456793727049",
      elements: [
        { id: "S1-34x23",     name: "Fire Dragon",         width_cm: 34, height_cm: 23, qty: 1 },
        { id: "S2-21x24",     name: "Ice Dragon",          width_cm: 21, height_cm: 24, qty: 1 },
        { id: "S3-23x32",     name: "Forest Dragon",       width_cm: 23, height_cm: 32, qty: 1 },
        { id: "S4-47x25",     name: "Flying Dragon",       width_cm: 47, height_cm: 25, qty: 1 },
        { id: "S5-35x34",     name: "Dragon with Egg",     width_cm: 35, height_cm: 34, qty: 1 },
        { id: "S6-26x26",     name: "Baby Dragon",         width_cm: 26, height_cm: 26, qty: 1 },
        { id: "S7-32x26",     name: "Sleeping Dragon",     width_cm: 32, height_cm: 26, qty: 1 },
        { id: "S8-17x9",      name: "Dragon Flame",        width_cm: 17, height_cm: 9,  qty: 1 },
        { id: "S9-7x9",       name: "Dragon Egg Blue",     width_cm: 7,  height_cm: 9,  qty: 1 },
        { id: "S10-8x9",      name: "Dragon Egg Green",    width_cm: 8,  height_cm: 9,  qty: 1 },
        { id: "S11-6x8",      name: "Dragon Egg Purple",   width_cm: 6,  height_cm: 8,  qty: 1 },
        { id: "S12-5x7",      name: "Dragon Egg Red",      width_cm: 5,  height_cm: 7,  qty: 1 },
        { id: "S13-6x6-x4",   name: "Gem",                 width_cm: 6,  height_cm: 6,  qty: 4 },
        { id: "S14-6x9-x2",   name: "Crystal",             width_cm: 6,  height_cm: 9,  qty: 2 },
        { id: "S15-4x4-x6",   name: "Star",                width_cm: 4,  height_cm: 4,  qty: 6 },
        { id: "S16-7x7",      name: "Shield",              width_cm: 7,  height_cm: 7,  qty: 1 },
        { id: "S17-3x3-x6",   name: "Sparkle",             width_cm: 3,  height_cm: 3,  qty: 6 },
        { id: "S18-4x6-x4",   name: "Magic Potion",        width_cm: 4,  height_cm: 6,  qty: 4 },
        { id: "S19-3x5-x2",   name: "Feather",             width_cm: 3,  height_cm: 5,  qty: 2 }
      ]
    },
    {
      id: "BH-DRAGON-XXL",
      sku: "BH-DRAGON-XXL",
      product_handle: "dragons-xxl-wall-decals",
      product_title: "Dragons XXL",
      type: "sticker_set",
      category: "sets",
      price: 6900,
      variantId: "54456793759817",
      elements: [
        { id: "S1-52x36",      name: "Fire Dragon",         width_cm: 52, height_cm: 36, qty: 1  },
        { id: "S2-31x35",      name: "Ice Dragon",          width_cm: 31, height_cm: 35, qty: 1  },
        { id: "S3-33x47",      name: "Forest Dragon",       width_cm: 33, height_cm: 47, qty: 1  },
        { id: "S4-61x33",      name: "Flying Dragon",       width_cm: 61, height_cm: 33, qty: 1  },
        { id: "S5-52x50",      name: "Dragon with Egg",     width_cm: 52, height_cm: 50, qty: 1  },
        { id: "S6-35x36",      name: "Baby Dragon",         width_cm: 35, height_cm: 36, qty: 1  },
        { id: "S7-46x37",      name: "Sleeping Dragon",     width_cm: 46, height_cm: 37, qty: 1  },
        { id: "S8-27x15",      name: "Dragon Flame",        width_cm: 27, height_cm: 15, qty: 1  },
        { id: "S9-10x13",      name: "Dragon Egg Blue",     width_cm: 10, height_cm: 13, qty: 1  },
        { id: "S10-11x12",     name: "Dragon Egg Green",    width_cm: 11, height_cm: 12, qty: 1  },
        { id: "S11-10x13",     name: "Dragon Egg Purple",   width_cm: 10, height_cm: 13, qty: 1  },
        { id: "S12-9x10",      name: "Dragon Egg Red",      width_cm: 9,  height_cm: 10, qty: 1  },
        { id: "S13-8x8-x3",    name: "Gem",                 width_cm: 8,  height_cm: 8,  qty: 3  },
        { id: "S14-8x12",      name: "Crystal",             width_cm: 8,  height_cm: 12, qty: 1  },
        { id: "S15-6x6-x7",    name: "Star",                width_cm: 6,  height_cm: 6,  qty: 7  },
        { id: "S16-5x5",       name: "Shield",              width_cm: 5,  height_cm: 5,  qty: 1  },
        { id: "S17-5x5-x12",   name: "Sparkle",             width_cm: 5,  height_cm: 5,  qty: 12 },
        { id: "S18-7x11-x2",   name: "Magic Potion",        width_cm: 7,  height_cm: 11, qty: 2  },
        { id: "S19-4x6-x5",    name: "Feather",             width_cm: 4,  height_cm: 6,  qty: 5  },
        { id: "S20-5x7-x5",    name: "Scroll",              width_cm: 5,  height_cm: 7,  qty: 5  }
      ]
    },
    {
      id: "BH-FISHING-XL",
      sku: "BH-FISHING-XL",
      product_handle: "fishing-bears-xl-wall-decals",
      product_title: "Fishing Bears XL",
      type: "sticker_set",
      category: "sets",
      price: 3300,
      variantId: "54456792383561",
      elements: [
        { id: "S1-54x40",      name: "Bear Fishing",        width_cm: 54, height_cm: 40, qty: 1  },
        { id: "S2-38x27",      name: "Bear with Catch",     width_cm: 38, height_cm: 27, qty: 1  },
        { id: "S3-35x21",      name: "Boat on Lake",        width_cm: 35, height_cm: 21, qty: 1  },
        { id: "S4-31x18",      name: "Fish Jumping",        width_cm: 31, height_cm: 18, qty: 1  },
        { id: "S5-16x16",      name: "Fishing Bucket",      width_cm: 16, height_cm: 16, qty: 1  },
        { id: "S6-5x5-x10",    name: "Splash",              width_cm: 5,  height_cm: 5,  qty: 10 },
        { id: "S7-3x3-x14",    name: "Bubble",              width_cm: 3,  height_cm: 3,  qty: 14 }
      ]
    },
    {
      id: "BH-FISHING-XXL",
      sku: "BH-FISHING-XXL",
      product_handle: "fishing-bears-xxl-wall-decals",
      product_title: "Fishing Bears XXL",
      type: "sticker_set",
      category: "sets",
      price: 5200,
      variantId: "54456792416329",
      elements: [
        { id: "S1-79x57",      name: "Bear Fishing",        width_cm: 79, height_cm: 57, qty: 1  },
        { id: "S2-53x35",      name: "Bear with Catch",     width_cm: 53, height_cm: 35, qty: 1  },
        { id: "S3-46x28",      name: "Boat on Lake",        width_cm: 46, height_cm: 28, qty: 1  },
        { id: "S4-37x20",      name: "Fish Jumping",        width_cm: 37, height_cm: 20, qty: 1  },
        { id: "S5-17x17",      name: "Fishing Bucket",      width_cm: 17, height_cm: 17, qty: 1  },
        { id: "S6-6x6-x12",    name: "Splash",              width_cm: 6,  height_cm: 6,  qty: 12 },
        { id: "S7-4x4-x21",    name: "Bubble",              width_cm: 4,  height_cm: 4,  qty: 21 }
      ]
    },
    {
      id: "BH-FOXES-XL",
      sku: "BH-FOXES-XL",
      product_handle: "foxes-xl-wall-decals",
      product_title: "Foxes XL",
      type: "sticker_set",
      category: "sets",
      price: 3500,
      variantId: "54456812568649",
      elements: [
        { id: "S1-67x7",   name: "Branch with Leaves",  width_cm: 67, height_cm: 7,  qty: 1 },
        { id: "S2-37x45",  name: "Fox on Branch",       width_cm: 37, height_cm: 45, qty: 1 },
        { id: "S3-36x85",  name: "Tree with Fox",       width_cm: 36, height_cm: 85, qty: 1 },
        { id: "S4-15x15",  name: "Fox Cub",             width_cm: 15, height_cm: 15, qty: 1 },
        { id: "S5-12x9",   name: "Hedgehog",            width_cm: 12, height_cm: 9,  qty: 1 },
        { id: "S6-13x9",   name: "Squirrel",            width_cm: 13, height_cm: 9,  qty: 1 },
        { id: "S7-8x9",    name: "Bird",                width_cm: 8,  height_cm: 9,  qty: 1 },
        { id: "S8-8x8",    name: "Mushroom",            width_cm: 8,  height_cm: 8,  qty: 1 },
        { id: "S9-5x7",    name: "Acorn",               width_cm: 5,  height_cm: 7,  qty: 1 }
      ]
    },
    {
      id: "BH-FOXES-XXL",
      sku: "BH-FOXES-XXL",
      product_handle: "foxes-xxl-wall-decals",
      product_title: "Foxes XXL",
      type: "sticker_set",
      category: "sets",
      price: 4600,
      variantId: "54456812601417",
      elements: [
        { id: "S1-100x11", name: "Branch with Leaves",  width_cm: 100, height_cm: 11, qty: 1 },
        { id: "S2-46x54",  name: "Fox on Branch",       width_cm: 46,  height_cm: 54, qty: 1, file: "BH-FOXES-XxL-S2-46x54.png" },
        { id: "S3-43x106", name: "Tree with Fox",       width_cm: 43,  height_cm: 106, qty: 1 },
        { id: "S4-20x20",  name: "Fox Cub",             width_cm: 20,  height_cm: 20, qty: 1 },
        { id: "S5-14x11",  name: "Hedgehog",            width_cm: 14,  height_cm: 11, qty: 1 },
        { id: "S6-16x11",  name: "Squirrel",            width_cm: 16,  height_cm: 11, qty: 1 },
        { id: "S7-8x9",    name: "Bird",                width_cm: 8,   height_cm: 9,  qty: 1 },
        { id: "S8-8x8",    name: "Mushroom",            width_cm: 8,   height_cm: 8,  qty: 1 },
        { id: "S9-5x7",    name: "Acorn",               width_cm: 5,   height_cm: 7,  qty: 1 }
      ]
    },
    {
      id: "BH-SLEEPY-STYLE1-1",
      sku: "BH-SLEEPY-STYLE1-1",
      product_handle: "sleepy-style-1-wall-decals",
      product_title: "Sleepy Style 1",
      type: "sticker_set",
      category: "sets",
      price: 2900,
      variantId: "54456805294153",
      elements: [
        { id: "S1-75x42",      name: "Sleeping Bear on Cloud", width_cm: 75, height_cm: 42, qty: 1  },
        { id: "S2-25x24",      name: "Moon",                   width_cm: 25, height_cm: 24, qty: 1  },
        { id: "S3-6x6-x11",    name: "Cloud",                  width_cm: 6,  height_cm: 6,  qty: 11 },
        { id: "S4-3x3-x22",    name: "Star",                   width_cm: 3,  height_cm: 3,  qty: 22 }
      ]
    },
    {
      id: "BH-SLEEPY-STYLE2-1",
      sku: "BH-SLEEPY-STYLE2-1",
      product_handle: "sleepy-style-2-wall-decals",
      product_title: "Sleepy Style 2",
      type: "sticker_set",
      category: "sets",
      price: 3100,
      variantId: "54456805326921",
      elements: [
        { id: "S1-56x31",     name: "Sleeping Bear",       width_cm: 56, height_cm: 31, qty: 1  },
        { id: "S2-46x32",     name: "Sleeping Bunny",      width_cm: 46, height_cm: 32, qty: 1  },
        { id: "S3-40x23",     name: "Sleeping Fox",        width_cm: 40, height_cm: 23, qty: 1  },
        { id: "S4-24x24",     name: "Sleeping Koala",      width_cm: 24, height_cm: 24, qty: 1  },
        { id: "S5-6x5-x7",    name: "Moon",                width_cm: 6,  height_cm: 5,  qty: 7  },
        { id: "S6-5x5-x10",   name: "Star",                width_cm: 5,  height_cm: 5,  qty: 10 }
      ]
    },
    {
      id: "BH-SLEEPY-STYLE3-1",
      sku: "BH-SLEEPY-STYLE3-1",
      product_handle: "sleepy-style-3-wall-decals",
      product_title: "Sleepy Style 3",
      type: "sticker_set",
      category: "sets",
      price: 3700,
      variantId: "54456805359689",
      elements: [
        { id: "S1-55x31",      name: "Sleeping Bear",       width_cm: 55, height_cm: 31, qty: 1  },
        { id: "S2-45x32",      name: "Sleeping Bunny",      width_cm: 45, height_cm: 32, qty: 1  },
        { id: "S3-42x25",      name: "Sleeping Fox",        width_cm: 42, height_cm: 25, qty: 1  },
        { id: "S4-38x22",      name: "Sleeping Deer",       width_cm: 38, height_cm: 22, qty: 1  },
        { id: "S5-20x20",      name: "Sleeping Koala",      width_cm: 20, height_cm: 20, qty: 1  },
        { id: "S6-6x6-x8",     name: "Moon",                width_cm: 6,  height_cm: 6,  qty: 8  },
        { id: "S7-3x3-x14",    name: "Star",                width_cm: 3,  height_cm: 3,  qty: 14 }
      ]
    },
    {
      id: "BH-MUSHROOM-L",
      sku: "BH-MUSHROOM-L",
      product_handle: "mushroom-forest-l-wall-decals",
      product_title: "Mushroom Forest L",
      type: "sticker_set",
      category: "sets",
      price: 3600,
      variantId: "54456783274057",
      elements: [
        { id: "S1-45x42",  name: "Mushroom House",      width_cm: 45, height_cm: 42, qty: 1 },
        { id: "S2-33x37",  name: "Fairy Mushroom",      width_cm: 33, height_cm: 37, qty: 1 },
        { id: "S3-25x23",  name: "Toadstool",           width_cm: 25, height_cm: 23, qty: 1 },
        { id: "S4-20x22",  name: "Forest Gnome",        width_cm: 20, height_cm: 22, qty: 1 },
        { id: "S5-13x14",  name: "Fly Agaric",          width_cm: 13, height_cm: 14, qty: 1 },
        { id: "S6-10x13",  name: "Small Mushroom",      width_cm: 10, height_cm: 13, qty: 1 },
        { id: "S7-14x8",   name: "Moss Log",            width_cm: 14, height_cm: 8,  qty: 1 },
        { id: "S8-12x8",   name: "Fern",                width_cm: 12, height_cm: 8,  qty: 1 },
        { id: "S9-10x12",  name: "Snail",               width_cm: 10, height_cm: 12, qty: 1 },
        { id: "S10-7x9",   name: "Ladybug",             width_cm: 7,  height_cm: 9,  qty: 1 },
        { id: "S11-9x10",  name: "Butterfly",            width_cm: 9,  height_cm: 10, qty: 1 }
      ]
    },
    {
      id: "BH-MUSHROOM-XL",
      sku: "BH-MUSHROOM-XL",
      product_handle: "mushroom-forest-xl-wall-decals",
      product_title: "Mushroom Forest XL",
      type: "sticker_set",
      category: "sets",
      price: 6900,
      variantId: "54456783306825",
      elements: [
        { id: "S1-58x55",      name: "Mushroom House",      width_cm: 58, height_cm: 55, qty: 1 },
        { id: "S2-46x51",      name: "Fairy Mushroom",      width_cm: 46, height_cm: 51, qty: 1 },
        { id: "S3-35x32",      name: "Toadstool",           width_cm: 35, height_cm: 32, qty: 1 },
        { id: "S4-28x31",      name: "Forest Gnome",        width_cm: 28, height_cm: 31, qty: 1 },
        { id: "S5-19x20",      name: "Fly Agaric",          width_cm: 19, height_cm: 20, qty: 1 },
        { id: "S6-13x17",      name: "Small Mushroom",      width_cm: 13, height_cm: 17, qty: 1 },
        { id: "S7-21x13",      name: "Moss Log",            width_cm: 21, height_cm: 13, qty: 1 },
        { id: "S8-16x11",      name: "Fern",                width_cm: 16, height_cm: 11, qty: 1 },
        { id: "S9-13x12-x2",   name: "Snail",               width_cm: 13, height_cm: 12, qty: 2 },
        { id: "S10-9x11",      name: "Ladybug",             width_cm: 9,  height_cm: 11, qty: 1 },
        { id: "S11-12x13",     name: "Butterfly",            width_cm: 12, height_cm: 13, qty: 1 },
        { id: "S12-10x9",      name: "Caterpillar",          width_cm: 10, height_cm: 9,  qty: 1 }
      ]
    },
    {
      id: "BH-SPACEBEAR-XL",
      sku: "BH-SPACEBEAR-XL",
      product_handle: "space-bear-xl-wall-decals",
      product_title: "Space Bear XL",
      type: "sticker_set",
      category: "sets",
      price: 2900,
      variantId: "54456809095241",
      elements: [
        { id: "S1-32x38",     name: "Astronaut Bear",      width_cm: 32, height_cm: 38, qty: 1 },
        { id: "S2-14x25",     name: "Rocket",              width_cm: 14, height_cm: 25, qty: 1 },
        { id: "S3-43x8",      name: "Star Banner",         width_cm: 43, height_cm: 8,  qty: 1 },
        { id: "S4-12x12",     name: "Planet",              width_cm: 12, height_cm: 12, qty: 1 },
        { id: "S5-4x3-x9",    name: "Star",                width_cm: 4,  height_cm: 3,  qty: 9 },
        { id: "S6-3x2-x6",    name: "Sparkle",             width_cm: 3,  height_cm: 2,  qty: 6 }
      ]
    },
    {
      id: "BH-SPACEBEAR-XXL",
      sku: "BH-SPACEBEAR-XXL",
      product_handle: "space-bear-xxl-wall-decals",
      product_title: "Space Bear XXL",
      type: "sticker_set",
      category: "sets",
      price: 3600,
      variantId: "54456809128009",
      elements: [
        { id: "S1-54x64",      name: "Astronaut Bear",      width_cm: 54, height_cm: 64, qty: 1  },
        { id: "S2-23x40",      name: "Rocket",              width_cm: 23, height_cm: 40, qty: 1  },
        { id: "S3-62x12",      name: "Star Banner",         width_cm: 62, height_cm: 12, qty: 1  },
        { id: "S4-17x17",      name: "Planet",              width_cm: 17, height_cm: 17, qty: 1  },
        { id: "S5-5x5-x12",    name: "Star",                width_cm: 5,  height_cm: 5,  qty: 12 },
        { id: "S6-3x3-x9",     name: "Sparkle",             width_cm: 3,  height_cm: 3,  qty: 9  }
      ]
    },
    {
      id: "BH-THREEBEARS-1",
      sku: "BH-THREEBEARS-1",
      product_handle: "three-bears-wall-decals",
      product_title: "Three Bears",
      type: "sticker_set",
      category: "sets",
      price: 5800,
      variantId: "54590958075977",
      elements: [
        { id: "S1-54x39",      name: "Papa Bear",           width_cm: 54, height_cm: 39, qty: 1  },
        { id: "S2-42x66",      name: "Mama Bear",           width_cm: 42, height_cm: 66, qty: 1  },
        { id: "S3-50x27",      name: "Baby Bear",           width_cm: 50, height_cm: 27, qty: 1  },
        { id: "S4-38x27",      name: "Bear on Swing",       width_cm: 38, height_cm: 27, qty: 1  },
        { id: "S5-35x21",      name: "Bear with Honey",     width_cm: 35, height_cm: 21, qty: 1  },
        { id: "S6-32x19",      name: "Bear Reading",        width_cm: 32, height_cm: 19, qty: 1  },
        { id: "S7-31x18",      name: "Bear Sleeping",       width_cm: 31, height_cm: 18, qty: 1  },
        { id: "S8-16x16",      name: "Beehive",             width_cm: 16, height_cm: 16, qty: 1  },
        { id: "S9-6x6-x18",    name: "Bee",                 width_cm: 6,  height_cm: 6,  qty: 18 },
        { id: "S10-3x3-x25",   name: "Paw Print",           width_cm: 3,  height_cm: 3,  qty: 25 }
      ]
    }
  ],

  // Отдельный элемент — стикер имени (добавляется к любому набору)
  name_sticker: {
    id: "name-sticker",
    name: "Add Name Sticker",
    type: "name_sticker",
    price: 0,
    variantId: null,
    width_cm: 30,
    height_cm: 8,
    personalization: {
      type: "text_only",
      default_text: "Emma",
      fonts: ["Nunito", "Pacifico", "Dancing Script", "Fredoka One"],
      colors: ["#2F3428", "#6B7F4A", "#D4937D", "#8FA76D", "#C17B5C"]
    }
  }
};
